import { create } from 'zustand';

interface TranscriptPanelState {
  isOpen: boolean;
  conversationId: string | null;
  highlightMessageId: string | null;
  open: (conversationId: string, highlightMessageId?: string) => void;
  close: () => void;
}

const useTranscriptPanelStore = create<TranscriptPanelState>((set) => ({
  isOpen: false,
  conversationId: null,
  highlightMessageId: null,
  open: (conversationId: string, highlightMessageId?: string) =>
    set({ isOpen: true, conversationId, highlightMessageId: highlightMessageId ?? null }),
  close: () => set({ isOpen: false, conversationId: null, highlightMessageId: null }),
}));

export default useTranscriptPanelStore;
